import React from 'react';
import { Typography, Link } from '@fiverr-private/typography';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '../../../utils/translate';

const LINK_QUERY_PARAMS = { store: 'false' };

const DisclaimerLink = ({ text, href }: { text: string; href: string }): any => (
    <Link decoration="underline" color="grey_900" href={href} target="_blank" rel="noreferrer noopener">
        {text}
    </Link>
);

export const Disclaimer = () => {
    const termsOfServicesLink = pathfinder('business_terms_of_service', undefined, { query: LINK_QUERY_PARAMS });
    const privacyPolicyLink = pathfinder('privacy_policy', undefined, { query: LINK_QUERY_PARAMS });

    return (
        <Typography marginTop="4" color="grey_900" size="b_xs">
            {translate('disclaimer', {
                templates: {
                    tos_link: (text?: string) => <DisclaimerLink href={termsOfServicesLink} text={text!} />,
                    privacy_link: (text?: string) => <DisclaimerLink href={privacyPolicyLink} text={text!} />,
                },
            })}
        </Typography>
    );
};
